"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledHyperlink = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const config_1 = require("../../../assets/styles/config");
exports.StyledHyperlink = styled_components_1.default.a `
  font: 500 ${config_1.fontSizes.small} ${config_1.fontFamilies.primary};
  color: ${config_1.colors.blurple};

  &:hover,
  &:focus {
    color: ${config_1.colors.indigo};
  }
`;
